import type { BuffetMealPeriod, BuffetPackage, IntegrationSettings } from '../types';

export const BUFFET_MEAL_PERIODS: { id: BuffetMealPeriod; label: string }[] = [
  { id: 'breakfast', label: 'Breakfast' },
  { id: 'lunch', label: 'Lunch' },
  { id: 'dinner', label: 'Dinner' },
];

/** Seed packages from legacy Settings breakfast/lunch/dinner prices when no packages exist. */
export function migrateLegacyBuffetPricing(
  settings: Pick<IntegrationSettings, 'buffetPackages' | 'buffetPricing'>,
): BuffetPackage[] {
  const existing = settings.buffetPackages ?? [];
  if (existing.length > 0) return existing;
  const pricing = settings.buffetPricing;
  if (!pricing) return [];
  const seeded: BuffetPackage[] = [];
  for (const { id, label } of BUFFET_MEAL_PERIODS) {
    const price = pricing[id];
    if (typeof price === 'number' && price > 0) {
      seeded.push({
        id: `legacy-${id}`,
        name: `${label} Buffet`,
        mealPeriod: id,
        price,
        isAvailable: true,
      });
    }
  }
  return seeded;
}

export function getBuffetPackages(
  settings: Pick<IntegrationSettings, 'buffetPackages' | 'buffetPricing'> | null | undefined,
  mealPeriod?: BuffetMealPeriod,
  opts?: { includeUnavailable?: boolean },
): BuffetPackage[] {
  if (!settings) return [];
  let list = settings.buffetPackages?.length
    ? settings.buffetPackages
    : migrateLegacyBuffetPricing(settings);
  if (!opts?.includeUnavailable) {
    list = list.filter((p) => p.isAvailable !== false && p.price > 0);
  }
  if (mealPeriod) {
    list = list.filter((p) => p.mealPeriod === mealPeriod);
  }
  return list;
}

export function newBuffetPackageId(): string {
  return `bp-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
